import { Component, Input, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatePipe } from '@angular/common';
import { GrievanceServicesService } from '../../__grievance-services/grievance-services.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-grievance-table',
  templateUrl: './grievance-table.component.html',
  styleUrls: ['./grievance-table.component.scss'],
})
export class GrievanceTableComponent  implements OnInit {
  @Input({required: true}) tableheadersAndData: any = [];
  @Input({required: true}) selectedTabIndex!: string;
  
  searchTerm!:any;
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: true,
    closeDropDownOnSelection: true
  };
  getLocationList: {id: String, name: any}[] = [];
  selectedGrievance!: any;
  tableData: any = [];
  isEditData: number | null = null;
  
  constructor(private datePipe:DatePipe, private grievanceServicesService: GrievanceServicesService, public dialog: MatDialog, public mobileResponsiveService: MobileResponsiveService, public toastr: ToastrService) { }
  
  ngOnInit() { 
    this.tableData = this.tableheadersAndData.tableData;
    
    console.log(this.tableheadersAndData);
    
    setTimeout(() => {
      if(this.tableheadersAndData?.tableData?.length > 0){      
        const location = Array.from( new Set(this.tableheadersAndData.tableData.map( (item:any) => item.grievanceType))).map((name, index) => (
          { id: (index + 1).toString(), name: name }
        ));
        this.getLocationList = location;
      } 
    }, 100);
  }
  
  
  onEditGrievance(tabType:string, event: any){
    
    const selectedData = this.tableData.filter( (item:any) => item.id === event)[0];
    const onEditGrievance = this.grievanceServicesService.onAddOrUpdateGrievanceModal({tabType: tabType, modalData: selectedData});
    onEditGrievance.afterClosed().subscribe( (data) => {
      
      if(data.status) {
        const udata = data.data;
        selectedData.grievanceType = this.grievanceServicesService.getGrevType(udata.grievanceType);
        selectedData.grievanceTypeKey = udata.grievanceType;
        selectedData.againstWhom = udata.againstWhom;
        selectedData.whomToSent = this.selectedTabIndex == 'allGrievance' ? udata.whomToSent : udata.raisedBy;
        selectedData.priority = udata.priority;
        selectedData.reason = udata.reason;
        
        selectedData.status = udata.status;
        selectedData.commentFromReceiver = udata.commentFromReceiver;
        selectedData.resolvedDate = udata.resolvedDate;
        selectedData.ifStatusInProgress = udata.status == 'IN_PROGRESS' ? true : false,
        selectedData.ifStatusClosed = udata.status == 'CLOSED' ? true : false,
        
        this.toastr.success(data.message);
        
        setTimeout(() => {
          this.grievanceServicesService.updateCounts(this.tableData);
        }, 400);
      } else {
        if(data.message) this.toastr.error(data.message);
      }
    });
  }
  
  
  deleteData(event: any){
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      panelClass: 'phi_mdc_dialog__container_100',
      data: {
        msg: 'Are Sure You Want To Delete?',
        btn1: 'Cancel',
        btn2: 'Yes',
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    
    dialogRef.afterClosed().subscribe( (data) => {
      if(data){
        this.grievanceServicesService.onDeleteGrievance(event).subscribe({
          next: (data:any) => {
            if(data.status) {
              const index = this.tableData.findIndex( (item:any) => item.id === event);
              if (index !== -1) this.tableData.splice(index, 1);
              this.toastr.success(data.message);
              
              setTimeout(() => {
                this.grievanceServicesService.updateCounts(this.tableData);
              }, 400);
            }
          },
        });
      }
    });
  }
  
  onSearchFilter(event: Event){
    this.tableData = structuredClone(this.tableheadersAndData.tableData);
    const target = event.target as HTMLIonSearchbarElement;
    const query = target.value?.toLowerCase() || '';
    this.tableData = this.tableData.filter((item: any) => {
      return Object.values(item).some(val => val && val.toString().toLowerCase().includes(query));
    });
  }
  
  onGrievanceType(){
    this.tableData = structuredClone(this.tableheadersAndData.tableData);
    if(!(this.selectedGrievance.length > 0)) return;
    if (this.selectedGrievance.length >= 0) this.tableData = this.tableData.filter((data: any) => data.grievanceType === this.selectedGrievance[0].name);
  }
  
  onDislaySelectedRecord(event: any){
    this.tableData = structuredClone(this.tableheadersAndData.tableData);
    this.tableData = this.tableData.slice(0, event.value);
  }
  
  downloadCSV(){
    this.grievanceServicesService.downloadAllOrAddressGrievance( this.tableheadersAndData);
  }
}
